import { Switch as SwitchPrimitive } from "@base-ui/react/switch";

function Switch({
	className,
	...props
}: React.ComponentProps<typeof SwitchPrimitive.Root>) {
	return (
		<SwitchPrimitive.Root
			{...props}
			className="cursor:pointer disabled:cursor-not-allowed relative flex h-6 w-12 rounded-full bg-gradient-to-r from-gray-300 from-35% to-white to-65% bg-[length:6.5rem_100%] bg-[100%_0%] bg-no-repeat p-px outline -outline-offset-1 outline-gray-300 transition-[background-position,box-shadow] duration-[125ms] ease-[cubic-bezier(0.26,0.75,0.38,0.45)] before:absolute before:rounded-full before:outline-offset-2 before:outline-accent-primary focus-visible:before:inset-0 focus-visible:before:outline focus-visible:before:outline-2 active:bg-orange-200 data-[checked]:bg-[0%_0%] data-[checked]:active:bg-orange-300"
		>
			<SwitchPrimitive.Thumb className="aspect-square h-full rounded-full bg-accent-primary shadow-[0_0_1px_1px,0_1px_1px,1px_2px_4px_-1px] shadow-gray-300 transition-transform duration-150 data-[checked]:translate-x-6" />
		</SwitchPrimitive.Root>
	);
}

export { Switch };
